export enum PackageUserRole {
    BORROWER = 'BORROWER',
    SIGNINGAGENT = 'SIGNINGAGENT',
    SYSTEM = 'SYSTEM',
    NBTH = 'NBTH',
    SELLER = 'SELLER',
    SIGNER = 'SIGNER',
    WITNESS = 'WITNESS'
}
